import { gql } from "@apollo/client";

export const CLIENT_ITEM_QUERY = gql`
  query client($id: Int!) {
    client(id: $id) {
      id
      user {
        id
        userName
        firstName
        lastName
        email
      }
      firstName
      lastName
      company
      email
      phone
      fax
      sex
      anumber
      phone1
      jobTitle
      accountName
      webAdress
      active
      createdAt
      updatedAt
      lastBillingAddress {
        id
        address
        city
        country {
          id
          name
          createdAt
          updatedAt
        }
        zip
        attentionTo
        client {
          id
          user {
            id
            userName
            firstName
            lastName
            email
          }
          firstName
          lastName
          company
          email
        }
        address2
        typeAddress
        isDelete
        createdAt
        updatedAt
      }
      defaultContact {
        id
        firstName
        lastName
        email
        phone1
        phone2
        jobTitle
        fax
        note
        shippingAddress {
          id
          address
          city
          state
          country {
            id
            name
            createdAt
            updatedAt
          }
          zip
          attentionTo
          client {
            id
            user {
              id
              userName
              firstName
              lastName
              email
            }
            firstName
            lastName
            company
            email
          }
        }
        billingAddress {
          id
          address
          city
          state
          country {
            id
            name
            createdAt
            updatedAt
          }
          zip
          attentionTo
          client {
            id
            user {
              id
              userName
              firstName
              lastName
              email
            }
            firstName
            lastName
            company
            email
          }
        }
        defaultShipping
        defaultBilling
        createdAt
        updatedAt
        client {
          id
          user {
            id
            userName
            firstName
            lastName
            email
          }
          firstName
          lastName
          company
          email
        }
        sex
        isDelete
        phone1Search
        phone2Search
        birthday
      }
      accessLevelCd
      temporaryAccessDate
      hasOrdered
      quoteQuantity
      cQuoteCoast
      isEnableAutomaticEmails
      clientContacts {
        id
        firstName
        lastName
        email
        phone1
        phone2
        jobTitle
        fax
        note
        shippingAddress {
          id
          address
          city
          state
          country {
            id
            name
            createdAt
            updatedAt
          }
          zip
          attentionTo
          client {
            id
            user {
              id
              userName
              firstName
              lastName
              email
            }
            firstName
            lastName
            company
            email
          }
        }
        billingAddress {
          id
          address
          city
          state
          country {
            id
            name
            createdAt
            updatedAt
          }
          zip
          attentionTo
          client {
            id
            user {
              id
              userName
              firstName
              lastName
              email
            }
            firstName
            lastName
            company
            email
          }
        }
        defaultShipping
        defaultBilling
        createdAt
        updatedAt
        client {
          id
          user {
            id
            userName
            firstName
            lastName
            email
          }
          firstName
          lastName
          company
          email
        }
        sex
        isDelete
        phone1Search
        phone2Search
        birthday
      }
      clientCreditCards {
        id
        holderName
        expirationDate
        cardNumber
        verificationNumber
        creditCardType
        isDelete
        createdAt
        updatedAt
        client {
          id
          firstName
          lastName
          company
          email
        }
      }
      shippingAddresses {
        id
        address
        city
        state
        country {
          id
          name
          createdAt
          updatedAt
        }
        zip
        attentionTo
        address2
        typeAddress
        createdAt
        isDelete
        updatedAt
        client {
          id
          user {
            id
          }
          firstName
          lastName
          company
          email
        }
      }
      industryTag {
        id
        name
        createdAt
        updatedAt
      }
    }
  }
`;

export const CLIENT_ITEM_TINY_QUERY = gql`
  query client($id: Int!) {
    client(id: $id) {
      id      
      firstName
      lastName
      company
      email
      phone
      fax
      sex
      anumber
      phone1
      jobTitle
      accountName
      webAdress
      active
      createdAt
      updatedAt      
      defaultContact {
        id
        firstName
        lastName
        email
        phone1
        phone2        
      }
    }
  }
`;
